import { render, staticRenderFns } from "./ContactListAdmin.vue?vue&type=template&id=0c23d188&scoped=true"
import script from "./ContactListAdmin.vue?vue&type=script&lang=js"
export * from "./ContactListAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c23d188",
  null
  
)

export default component.exports